import request from "@/utils/request.js";
// 人脸检索无图
export const queryinstalled = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/znyy/face/structure-search",
    method: "post",
    data: data
  });
};

// 过人记录
export const faceRecord = data => {
  return request({
    url: "/apiData/hz-data-community/styp/face_search_detail/face/record",
    method: "post",
    data: data
  });
};

// 过人记录
export const faceRecordExport = data => {
  return request({
    url: "/apiData/hz-data-community/styp/face_search_detail/face/record/export",
    method: "post",
    data: data,
    responseType: "blob"
  });
};
// 人脸检索有图
export const facemanymany = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/znyy/face/many/image-search",
    method: "post",
    data: data
  });
};

// 人体检索无图
export const structuresearch = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/znyy/body/structure-search",
    method: "post",
    data: data
  });
};
// 人体检索有图
export const imagesearch = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/znyy/body/image-search",
    method: "post",
    data: data
  });
};
// 背影无图有图
export const searchface = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/znyy/body/search-face",
    method: "post",
    data: data
  });
};

// 特征有图
export const partsearch = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/znyy/body/part-search",
    method: "post",
    data: data
  });
};

// 获取名单库列表信息
export const repositorylist = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/znyy/identity/repository-list",
    method: "post",
    data: data
  });
};
// 地址转照片  自动系统
export const url2ToBase = data => {
  return request({
    url: "/apiData/hz-data-community/smart/safety/url2Base64",
    method: "post",
    data: data
  });
};
// 地址转照片  华智
export const urlToBase = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/view_judge/url-to-base64",
    method: "get",
    params: data
  });
};

// 地址转照片 6.1后（华智）
export const addrTrans = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/viid/addr-trans",
    method: "POST",
    data: data
  });
};
// 地址转Blob
export const urlToBlob = url => {
  return request({
    url: `/imgApi/${url}`,
    responseType: "blob"
  });
};